// import React from 'react';

// export function format(num) {
// 	if (num < 3600) {
// 		const minutes = padZero(Math.floor(num / 60), 2);
// 		const seconds = padZero(num % 60, 2);
// 		return `${minutes}:${seconds}`;
// 	} else {
// 		const hours = padZero(Math.floor(num / 3600), 2);
// 		const minutes = padZero(Math.floor((num - hours * 3600) / 60), 2);
// 		const seconds = padZero(num % 60, 2);
// 		return `${hours}:${minutes}:${seconds}`;
// 	}
// }

// function padZero(num, size) {
// 	let s = String(num);
// 	while (s.length < size) {
// 		s = `0${s}`;
// 	}
// 	return s;
// }

const format = (value) => {
	// const date = new Date(seconds * 1000);
	// const hh = date.getUTCHours();
	// const mm = date.getUTCMinutes();
	// const ss = pad(date.getUTCSeconds());
	// if (hh) {
	// 	return `${hh}:${pad(mm)}:${ss}`;
	// }
	// return `${mm}:${ss}`;
	let hours = Math.floor(value / 3600);
	let minutes = `0${Math.floor((value % 3600) / 60)}`.slice(-2);
	let seconds = `0${Math.floor(value % 60)}`.slice(-2);
	let formattedTime;

	if (hours) {
		formattedTime = `${hours}:${minutes}:${seconds}`;
	} else {
		formattedTime = `${minutes}:${seconds}`;
	}
	return formattedTime;
};

export const Duration = ({ className, seconds }) => {
	// const [time, setTime] = useState(format(seconds));
	// const renderSecond = useCallback(() => {
	//     if (progress) {

	//     }
	//     return format(seconds);
	// }, [])

	// const handleClick = () => {
	//     if (progress) {
	//         const remainTime = seconds - progress
	//         setTime(remainTime);
	//     }
	// };

	return <span className={className}>{format(seconds)}</span>;
};
